export default "__VITE_ASSET__3b07770b__"